<template>
  <div class="panel-thumb">
    <a :href="event.url" target="_blank">
      <div class="panel-header">
        <img v-lazy="event.image" :alt="event.name" class="thumb" />
      </div>
      <div class="panel-body">
        <h3 class="panel-name">{{ event.name }}</h3>
        <p v-html="eventDate" class="panel-date"></p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    eventDate() {
      const startDate = this.$options.filters.date_format(
        this.event.start_date,
        'YYYY年M月D日(ddd)'
      )
      const endDate = this.$options.filters.date_format(
        this.event.end_date,
        'YYYY年M月D日(ddd)'
      )
      const startTime = this.$options.filters.date_format(
        this.event.start_date,
        'HH:mm'
      )
      const endTime = this.$options.filters.date_format(
        this.event.end_date,
        'HH:mm'
      )

      if (startDate === endDate) {
        return `${startDate}<br />${startTime}〜${endTime}`
      } else {
        return `${startDate} ${startTime}<br />〜${endDate} ${endTime}`
      }
    }
  }
}
</script>
